import React, { useState } from 'react';
import { useAuth } from '@/lib/AuthContext';
import { api } from '@/api/apiClient';
import { Button } from '@/components/ui/button';
import DeleteAccount from '@/components/DeleteAccount';

export default function PendingApproval() {
  const { user, refreshUser, logout } = useAuth();
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  async function resend() {
    setBusy(true);
    try { await api.auth.emails.resendVerification(user.email); setMessage('Verification email sent.'); }
    catch (err) { setMessage(err.message); }
    finally { setBusy(false); }
  }
  return <main className="max-w-lg mx-auto p-6 min-h-screen flex flex-col justify-center">
    <h1 className="text-2xl font-bold mb-4">{user.deletion_pending ? 'Account deletion pending' : user.approval_status === 'rejected' || user.archived ? 'Access not approved' : 'Awaiting administrator acceptance'}</h1>
    <p className="text-slate-600 mb-4">Seiko Event Portal is for staff and freelancers working with Seiko Sports Technologies. An administrator must confirm that you work with us and accept your account before you can access any event or operational information.</p>
    {!user.email_verified && user.approval_status === 'pending' && <div className="mb-4 space-y-2">
      <p>Verify your email using the link we sent before your account can be accepted.</p>
      <Button variant="outline" disabled={busy} onClick={resend}>Resend verification email</Button>
    </div>}
    {message && <p role="status" className="mb-4">{message}</p>}
    <div className="flex gap-3"><Button onClick={() => refreshUser()}>Check status</Button><Button variant="outline" onClick={() => logout()}>Sign out</Button></div>
    <DeleteAccount />
  </main>;
}
